module.exports = __webpack_public_path__ + "static/img/CO@3x.653d48c1.jpg";